import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Container,
    Card,
    CardContent,
    CircularProgress,
    List,
    ListItem,
} from "@mui/material";

function Government() {
    const [government, setGovernment] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios({
            method: "GET",
            url: "/files/industries/government.txt",
        }).then((res) => {
            setGovernment(res.data);
            setLoading(false);
        });
    }, []);

    return (
        <Container maxWidth="md" sx={{ py: 2 }}>
            {/* Title */}
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem",  // mobile (~h4)
                        sm: "2.2rem",  // tablet (~h3)
                        md: "2.8rem",  // laptop (~h3+)
                        lg: "3rem",    // desktop (~h2)
                    },
                }}
            >
                Government
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress color="secondary" />
                </Box>
            ) : (
                <>
                    {government &&
                        government.map((item, index) => (
                            <Box key={index} mb={3}>
                                {typeof item === "string" ? (
                                    <Typography
                                        variant="body1"
                                        sx={{ mb: 2, fontSize: "18px", textAlign: "justify" }}
                                    >
                                        {item}
                                    </Typography>
                                ) : (
                                    Object.entries(item).map(([key, value]) => (
                                        <Box key={key} mb={2}>
                                            <Typography
                                                variant="h6"
                                                sx={{ fontWeight: "600", color: "#030366", mb: 1 }}
                                            >
                                                {key}
                                            </Typography>
                                            {typeof value === "string" ? (
                                                <Typography
                                                    variant="body1"
                                                    sx={{ mb: 2, textAlign: "justify" }}
                                                >
                                                    {value}
                                                </Typography>
                                            ) : (
                                                <List sx={{ pl: 3 }}>
                                                    {value &&
                                                        value.map((subitem, i) => (
                                                            <ListItem
                                                                key={i}
                                                                sx={{
                                                                    display: "list-item",
                                                                    listStyleType: "disc",
                                                                    pl: 1,
                                                                    fontSize: "16px",
                                                                }}
                                                            >
                                                                {subitem}
                                                            </ListItem>
                                                        ))}
                                                </List>
                                            )}
                                        </Box>
                                    ))
                                )}
                            </Box>
                        ))}
                </>
            )}
        </Container>
    );
}

export default Government;
